import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { Tooltip } from '@mui/material';
import { Toolbar, ToolbarButton } from '@mui/x-data-grid-pro';

interface CustomToolbarProps {
  onExport: () => void;
}

declare module '@mui/x-data-grid' {
  interface ToolbarPropsOverrides {
    onExport: () => void;
  }
}

const CustomToolbar = ({ onExport }: CustomToolbarProps) => {
  return (
    <Toolbar>
      <Tooltip title="Export to Excel">
        <ToolbarButton onClick={() => onExport()}>
          <FileDownloadIcon fontSize="small" />
        </ToolbarButton>
      </Tooltip>
    </Toolbar>
  );
};

export default CustomToolbar;
